import { TrackingEventIds } from "./../tracking/constants/TrackingEventIds";
import { BulkLoader } from "./../loader/BulkLoader";
import { ConnectionTrackingEvent } from "./../tracking/ConnectionTrackingEvent";
import { GoodgameAdvancedTextFieldFactory } from "./../textfield/manager/GoodgameAdvancedTextFieldFactory";
import { GoodgameTextFieldManager } from "./../textfield/manager/GoodgameTextFieldManager";
import { ITextFieldManager } from "./../textfield/manager/ITextFieldManager";
import { GoodgamePartners } from "./../constants/GoodgamePartners";
import { CookieLogLOFactory } from "./../externalLogging/factories/CookieLogLOFactory";
import { SupportUtil } from "./../misc/SupportUtil";
import { TrackingCache } from "./../tracking/TrackingCache";
import { PerformanceMonitoringEnvTypeEnum } from "./../profiling/enum/PerformanceMonitoringEnvTypeEnum";
import { PerformanceMonitoringService } from "./../profiling/service/PerformanceMonitoringService";
import { CampaignVarsVO } from "./../marketing/google/CampaignVarsVO";
import { ExternalLog } from "./../externalLogging/ExternalLog";
import { CommandController } from "./../commanding/CommandController";
import { VersionInformation } from "./VersionInformation";
import { IEnvironmentGlobals } from "./IEnvironmentGlobals";
import { ConfigFilesVersionsModel } from "./configuration/ConfigFilesVersionsModel";
import { BasicConstants } from "./constants/BasicConstants";
import { BasicController } from "./controller/BasicController";
import { BasicChangeLanguageCommand } from "./controller/clientCommands/BasicChangeLanguageCommand";
import { BasicHandleIdentityManagementErrorCommand } from "./controller/clientCommands/BasicHandleIdentityManagementErrorCommand";
import { BasicIdentityManagementCommand } from "./controller/clientCommands/BasicIdentityManagementCommand";
import { BasicInitZoneCapacityCommand } from "./controller/clientCommands/BasicInitZoneCapacityCommand";
import { BasicNetworkUpdateCommand } from "./controller/clientCommands/BasicNetworkUpdateCommand";
import { BasicReloadNetworkCommand } from "./controller/clientCommands/BasicReloadNetworkCommand";
import { BasicReloadPageWithZoneIdCommand } from "./controller/clientCommands/BasicReloadPageWithZoneIdCommand";
import { BasicReportSurveyCommand } from "./controller/clientCommands/BasicReportSurveyCommand";
import { BasicRequestSocialLoginKeysCommand } from "./controller/clientCommands/BasicRequestSocialLoginKeysCommand";
import { BasicSendClientLoginTrackingCommand } from "./controller/clientCommands/BasicSendClientLoginTrackingCommand";
import { BasicTrackRegistrationDataCommand } from "./controller/clientCommands/BasicTrackRegistrationDataCommand";
import { ChooseLoginMethodCommand } from "./controller/clientCommands/ChooseLoginMethodCommand";
import { BasicCheckAgeGateActivityCommand } from "./controller/clientCommands/ageGate/BasicCheckAgeGateActivityCommand";
import { BasicValidateAgeCommand } from "./controller/clientCommands/ageGate/BasicValidateAgeCommand";
import { GGSTrackEventCommand } from "./controller/clientCommands/google/GGSTrackEventCommand";
import { BasicConnectionTrackingCommand } from "./controller/clientCommands/tracking/BasicConnectionTrackingCommand";
import { BasicDesktopDeviceInformationTrackingCommand } from "./controller/clientCommands/tracking/BasicDesktopDeviceInformationTrackingCommand";
import { BasicFacebookConnectionTrackingCommand } from "./controller/clientCommands/tracking/BasicFacebookConnectionTrackingCommand";
import { BasicFacebookUserDataTrackingCommand } from "./controller/clientCommands/tracking/BasicFacebookUserDataTrackingCommand";
import { BasicInvitationTrackingCommand } from "./controller/clientCommands/tracking/BasicInvitationTrackingCommand";
import { BasicPaymentShopClickTrackingCommand } from "./controller/clientCommands/tracking/BasicPaymentShopClickTrackingCommand";
import { BasicProfilingTrackingCommand } from "./controller/clientCommands/tracking/BasicProfilingTrackingCommand";
import { BasicVerifyTrackingCommand } from "./controller/clientCommands/tracking/BasicVerifyTrackingCommand";
import { BasicWorldAssignmentTrackingCommand } from "./controller/clientCommands/tracking/BasicWorldAssignmentTrackingCommand";
import { PathProvider } from "./environment/providers/PathProvider";
import { BasicAssetsEvent } from "./event/BasicAssetsEvent";
import { BasicFirstVisitEvent } from "./event/BasicFirstVisitEvent";
import { LanguageDataEvent } from "./event/LanguageDataEvent";
import { BasicFacebookConnectCommand } from "./fb/connectlogin/BasicFacebookConnectCommand";
import { BasicInitializeFacebookConnectCommand } from "./fb/connectlogin/BasicInitializeFacebookConnectCommand";
import { LoaderObject } from "./loading/LoaderObject";
import { BasicModel } from "./model/BasicModel";
import { BasicLanguageData } from "./model/components/BasicLanguageData";
import { BasicLoaderData } from "./model/components/BasicLoaderData";
import { BasicBackgroundComponent } from "./view/BasicBackgroundComponent";
import { BasicLanguageFontManager } from "./view/BasicLanguageFontManager";
import { ExtraScreenMovieClip } from "./view/firstVisit/ExtraScreenMovieClip";
import { BasicGGSTextFieldMouseOutBehaviour } from "./view/textField/behaviour/BasicGGSTextFieldMouseOutBehaviour";
import { BasicGGSTextFieldMouseOverBehaviour } from "./view/textField/behaviour/BasicGGSTextFieldMouseOverBehaviour";
// import { Modularity } from "../core/Modularity"; // TODO: @HTML5 unhandled Modularity class
import { LocalizationModule, GlobalizeTextProcessor, LanguageVO } from "@goodgamestudios/localization";
// TODO: @HTML5 Capabilities management - add additional egret classes, current;y it's more mocked up data handler
import { Capabilities, Timer, URLLoaderDataFormat } from "@goodgamestudios/createjs-utilities";
import { BasicConnectClientCommand } from "./controller/clientCommands/BasicConnectClientCommand";
import { EnvGlobalsHandler } from "./EnvGlobalsHandler";
import { getLogger } from "@goodgamestudios/logger";
import { WorldAssignment } from "@goodgamestudios/world-assignment";
import { BasicGame } from "./BasicGame";
import { BasicVersions } from "./version/BasicVersions";
import { ClientFunnelTrackingController } from "../tracking/clientFunnel/ClientFunnelTrackingController";
import { ClientFunnelGameStates } from "../tracking/clientFunnel/ClientFunnelGameStates";
export { CommandController } from "../commanding/CommandController";
export { GoodgamePartners } from "../constants/GoodgamePartners";
export { ExternalLog } from "../externalLogging/ExternalLog";
export { CookieLogLOFactory } from "../externalLogging/factories/CookieLogLOFactory";
export { GGSCountryController } from "../language/countryMapper/GGSCountryController";
export { CampaignVarsVO } from "../marketing/google/CampaignVarsVO";
export { BulkLoader } from "../loader/BulkLoader";
import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import ProgressEvent = createjs.ProgressEvent;
// TODO: @HTML5 StageAlign&StageScaleMode Management - should be handled using css
// import StageAlign = createjs.StageAlign;
// import StageScaleMode = createjs.StageScaleMode;
import Stage = createjs.Stage;
import Event = createjs.Event;
import TimerEvent = createjs.TimerEvent;
const logger = getLogger("BasicFrameOne");

/*
 * $URL$
 * $Rev$
 * $Author$
 * $Date$
 * $Id$
 */
export abstract class BasicFrameOne extends Stage {

    public static VERSION: string = "$Id$";
    public static NAME: string = "BasicFrameOne";

    /** first view of game. */
    protected preloaderView: BasicBackgroundComponent;
    /** timer to update preloader gfx. */
    protected preloaderUpdateTimer: Timer = new Timer(100);
    /** container for user first-visit. */
    protected firstVisitSreen: ExtraScreenMovieClip;

    protected worldAssignemnt: WorldAssignment;

    // protected _modularity: Modularity; // TODO: @HTML5 unhandled Modularity class
    protected _modularity: any;


    // TODO: @HTML5 for when we decide about modularity.  adding module to it, or if modularity will be dropped, use thhis reference of module somewhere to eventually unitialize/destroy ?
    protected localizationModule: LocalizationModule;


    constructor(canvasId: string) {
        super(canvasId);
        logger.debug("BasicFrameOne constructor");
        // Security.allowDomain("*"); // TODO: @HTML5 handle Security class

        // save file size
        // this.env.gameFileSize = String(Math.round(this.loaderInfo.bytesTotal / 1024));
        this.worldAssignemnt = window.ggs.worldAssignment;
        BasicModel.instanceProxy.setWorldAssignementFacade(this.worldAssignemnt.facade);
        logger.debug(this.worldAssignemnt);
        this.onAddedToStage();

        PerformanceMonitoringService.getInstance().init(PerformanceMonitoringEnvTypeEnum.Web, this);
    }

    private initLocalizationModule(): Promise<any> {
        this.localizationModule = new LocalizationModule(new GlobalizeTextProcessor(PathProvider.instance.cldrConfigURL, false), true);
        //Load German locale as the default so it forces the Globalize to load default data synchronously (EN, DE and supplemental)
        this.localizationModule.initialize(new LanguageVO(
            "DE",
            "de",
            this.env.neverUseAbbreviations,
            this.env.abbreviationThreshold,
            this.env.fractionalDigits,
            this.env.leadingZero,
            this.env.trailingZeros),
            {},
            null,
            this.env.isTest || this.env.isLocal);
        this.localizationModule.localizationService.localizeReplacements = this.env.localizeReplacements;
        return this.localizationModule.setLanguageAsync(new LanguageVO(
            this.worldAssignemnt.facade.currentCountry.ggsCountryCode,
            this.worldAssignemnt.facade.currentCountry.ggsLanguageCode,
            this.env.neverUseAbbreviations,
            this.env.abbreviationThreshold,
            this.env.fractionalDigits,
            this.env.leadingZero,
            this.env.trailingZeros
        ), {});
    }

    /**
     * is executed when frameone-swf added to stage
     * Set Environment-Variables by Flash-Vars and Url
     * Start loading Game-swfs (game, itemlibs, inteface etc) and start loading networkxml
     */
    private onAddedToStage(): void {
        // enabling mouse events
        this.stage.enableMouseOver(12);
        // setting snapToPixel
        this.stage.snapToPixelEnabled = true;


        this.registerCommands();

        //
        // Init logger
        CommandController.instance.executeCommand(BasicController.COMMAND_INIT_LOGGER, this.stage);

        // Call hook
        this.isAddedToStage();

        this.initLocalizationModule().then(() => {
            // Init managers and models for font and language handling needed for text rendering
            this.initTextRendering();

            // init versionInformation of xml-data
            this.setVersionInfo();

            //----------------------------------
            //	Draw debug information to the screen
            //----------------------------------
            // TODO: @HTML5  FORGET ABOUT THIS NOW :    BasicDebugHud.showDebugInformationHud(this.stage);

            // Configure stage
            // TODO: @HTML5 StageAlign&StageScaleMode Management - should be handled using css
            /*
             this.stage.scaleMode = StageScaleMode.NO_SCALE;
             this.stage.align = StageAlign.TOP_LEFT;
             */

            ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.FIRST_GAME_SCREEN);

            //----------------------------------
            //	init SupportUtil
            //----------------------------------
            let os: string = Capabilities.os;
            SupportUtil.initForWeb(this.env.referrer, this.env.gameId, this.env.sessionId, this.env.networkId, Capabilities.version, os);

            BasicModel.basicLoaderData = new BasicLoaderData();
            BasicModel.basicLoaderData.appLoader.loadingQueueElementStarted.add(this.bindFunction(this.handleNewLoadingElementStarted));
            BasicModel.basicLoaderData.appLoader.loadingQueueElementFinished.add(this.bindFunction(this.handleLoadingElementFinished));

            BasicFacebookConnectCommand.gameID = this.env.gameId;

            // call hook
            this.isAddedToStageDone();

            // Load version.json file
            this.loadVersion();
        }).catch(error => {
            logger.debug(`Error in Localization loader: ${error}`)
        });
    }

    private onFlushFailedAfterPending(): void {
        ExternalLog.logger.log(new CookieLogLOFactory(CookieLogLOFactory.COOKIE_PENDING_FAILED));
    }

    protected registerCommands(): void {

        CommandController.instance.registerCommand(BasicController.COMMAND_CONNECT_CLIENT, BasicConnectClientCommand);

        CommandController.instance.registerCommand(BasicController.COMMAND_INIT_LOGGER, this.initLoggerCommandClass);
        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_LOGIN, BasicSendClientLoginTrackingCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_RELOAD_NETWORK, BasicReloadNetworkCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_UPDATE_NETWORK, BasicNetworkUpdateCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_IDENTITY_MANAGEMENT, BasicIdentityManagementCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_HANDLE_IDENTITY_MANAGEMENT_ERROR, BasicHandleIdentityManagementErrorCommand);
        // AgeGate
        CommandController.instance.registerCommand(BasicController.COMMAND_CHECK_AGE_GATE_ACTIVITY, BasicCheckAgeGateActivityCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_VALIDATE_AGE, BasicValidateAgeCommand);

        // Tracking
        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_REGISTRATION_DATA, BasicTrackRegistrationDataCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_PROFILING, BasicProfilingTrackingCommand);

        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_WORLD_ASSIGNMENT, BasicWorldAssignmentTrackingCommand, null, true);
        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_CONNECTION_TRACKING_EVENT, BasicConnectionTrackingCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_GAME_PAYMENT_SHOP_CLICK_EVENT, BasicPaymentShopClickTrackingCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_DESKTOP_DEVICE_INFORMATION_EVENT, BasicDesktopDeviceInformationTrackingCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_VERIFY_TRACKING, BasicVerifyTrackingCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_INVITATION, BasicInvitationTrackingCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_FACEBOOK_CONNECTION, BasicFacebookConnectionTrackingCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_TRACK_FACEBOOK_USERDATA, BasicFacebookUserDataTrackingCommand);

        CommandController.instance.registerCommand(BasicController.COMMAND_CHANGE_LANGUAGE, BasicChangeLanguageCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_REPORT_SURVEY, BasicReportSurveyCommand);

        CommandController.instance.registerCommand(BasicController.REQUEST_SOCIAL_LOGIN_KEYS, BasicRequestSocialLoginKeysCommand);
        CommandController.instance.registerCommand(BasicController.CHOOSE_LOGIN_METHOD, ChooseLoginMethodCommand);

        CommandController.instance.registerCommand(BasicController.COMMAND_INIT_ZONE_CAPACITY, BasicInitZoneCapacityCommand);

        CommandController.instance.registerCommand(BasicController.GTM_CALL_GGS_TRACK_EVENT, GGSTrackEventCommand);

        CommandController.instance.registerCommand(BasicController.COMMAND_RELOAD_PAGE_WITH_ZONE_ID, BasicReloadPageWithZoneIdCommand);

        this.initPreClientCommands();
    }

    protected initPreClientCommands(): void {
        CommandController.instance.registerCommand(BasicController.COMMAND_FACEBOOK_INITIALIZE, BasicInitializeFacebookConnectCommand);
    }

    /**
     * Hook method to inject specific InitLoggerCommand  (implementation must return an extension of BasicInitLoggerCommand )
     */
    protected abstract get initLoggerCommandClass(): any;

    protected setVersionInfo(): void {
        let instance: VersionInformation = VersionInformation.versionInstance;
        this.env.setVersionInformation(instance);
    }

    private initTextRendering(): void {
        // Instantiate language model
        BasicModel.languageData = new BasicLanguageData(VersionInformation.versionInstance, PathProvider.instance, this.localizationModule);

        // Initialize text manager
        let textFieldManager: ITextFieldManager = GoodgameTextFieldManager.getInstance();

        // Pass language model reference
        textFieldManager.languageData = BasicModel.languageData;

        // Configure behaviours
        this.initTextFieldBehaviours();

        // Init TextField factory
        this.initTextFieldFactory(textFieldManager);
    }

    /**
     * Hook to use your own mouse behaviours
     */
    protected initTextFieldBehaviours(): void {
        let textFieldManager: ITextFieldManager = GoodgameTextFieldManager.getInstance();
        textFieldManager.mouseOverBehaviour = new BasicGGSTextFieldMouseOverBehaviour();
        textFieldManager.mouseOutBehaviour = new BasicGGSTextFieldMouseOutBehaviour();
    }

    /**
     * Hook to use your own text field factory
     */
    protected initTextFieldFactory(textFieldManager: ITextFieldManager): void {
        (textFieldManager as ITextFieldManager).textFieldFactory = new GoodgameAdvancedTextFieldFactory();
    }

    protected isAddedToStage(): void {
        //for overwriting
    }

    protected isAddedToStageDone(): void {
        //for overwriting
    }


    private loadVersion(): void {
        // force to load the version.json from media subdomain
        this.env.fallBackCDN = true;
        // Load version.json
        ConfigFilesVersionsModel.instance.loadVersionJson(PathProvider.instance.versionURL)
            .then(this.bindFunction(this.onVersionsInitialized))
            .catch((reason) => logger.warn(`loadingVersionJSON failed ${reason}`));
    }


    private onVersionsInitialized(): void {
        // removing the fallback flag for the other files
        this.env.fallBackCDN = false;
        this.loadItemVersionXML();
    }


    protected loadItemVersionXML(): void {
        //load gameTitle + Version.properties
        if (this.env.useItemXML) {
            BasicModel.basicLoaderData.appLoader.addXMLLoader(
                BasicConstants.ITEM_XML_VERSION,
                PathProvider.instance.itemsVersionURL,
                URLLoaderDataFormat.TEXT,
                this.bindFunction(this.onVersionPropertiesLoaded)
            );
        }
        else {
            this.onVersionPropertiesLoaded();
        }
    }

    private onVersionPropertiesLoaded(): void {
        //----------------------------------
        //	Initalize preloder view
        //----------------------------------
        this.createView();

        //-------------------------------------------------------------
        //	Filter version number and set in BasicVersions.as
        //-------------------------------------------------------------

        if (this.env.useItemXML) {
            let version: string = BasicModel.basicLoaderData.appLoader.getLoaderData(BasicConstants.ITEM_XML_VERSION).toString();
            BasicVersions.itemXMLVersion = version.substr(version.indexOf("=") + 1).trim();
        }
        this.onLanguagePropertiesLoaded();

    }

    protected onViewLoaded(): void {
        this.preloaderView.showProgressBar();
        this.addChildAt(this.preloaderView.disp, 0);
        this.preloaderUpdateTimer.addEventListener(TimerEvent.TIMER, this.bindFunction(this.onUpdatePreloaderView));
        this.preloaderUpdateTimer.start();
        this.preloaderView.show();
        this.preloaderView.showVersion();
        this.preloaderView.updatePosition();
        this.preloaderView.setProgressbarUpdateMethod(true);
        this.showFirstScreen();
        if (this.env.useItemXML) {
            this.loadXMLs();
        } else {
            this.loadAssets();
        }
    }

    /**
     * is executed when languageProperties-file complete loaded
     * define current language by network-defaultLanguage or FlashPlayer-Language (Capabilities.language)
     * Start EnterFrame and show preloaderview
     */

    private onLanguagePropertiesLoaded(): void {
        this.loadLanguage();
    }


    protected loadLanguage(): void {
        // Detect if age gate validation is needed (country muse )
        CommandController.instance.executeCommand(BasicController.COMMAND_CHECK_AGE_GATE_ACTIVITY, this.worldAssignemnt.facade.currentCountry);

        BasicModel.languageData.addEventListener(LanguageDataEvent.XML_LOAD_COMPLETE, this.bindFunction(this.onLanguageXMLComplete));
        this.env.currentCountryLanguageCode = this.worldAssignemnt.facade.currentCountry.ggsLanguageCode;
        this.env.currentCountryLanguageVersion = ConfigFilesVersionsModel.instance.languageVersion(this.env.currentCountryLanguageCode);
        //  TODO @HTML5  PathProvider.instance.languageConfigURL  is   empty      investigate
        BasicModel.languageData.loadLanguage();

        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.LANG_XML_START);
    }

    protected onLanguageXMLComplete(event: LanguageDataEvent): void {
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.LANG_XML_END);
        BasicModel.languageData.removeEventListener(LanguageDataEvent.XML_LOAD_COMPLETE, this.bindFunction(this.onLanguageXMLComplete));
        BasicLanguageFontManager.getInstance().addEventListener(LanguageDataEvent.FONT_LOAD_COMPLETE, this.bindFunction(this.onFontsLoaded));
        BasicLanguageFontManager.getInstance().loadFontsByLanguage();
    }


    private onFontsLoaded(event: LanguageDataEvent): void {
        logger.debug("onFontsLoaded ", "::", event);
        BasicLanguageFontManager.getInstance().removeEventListener(LanguageDataEvent.FONT_LOAD_COMPLETE, this.bindFunction(this.onFontsLoaded));
        logger.debug("useLegacyFontManagement -> Update all GoodgameTextFields");
        GoodgameTextFieldManager.getInstance().updateTextInAllTextFields();
    };


    protected showFirstScreen(): void {
        // FOR OVERRRIDE
    }

    protected /*final*/ initFirstVisitScreen(firstVisitScreen: ExtraScreenMovieClip): void {
        this.firstVisitSreen = firstVisitScreen;
        this.firstVisitSreen.addEventListener(BasicFirstVisitEvent.AVATARCREATION_FINISHED, this.bindFunction(this.onFirstVisitAvatarCreationFinished));
        this.addChild(this.firstVisitSreen.disp);
        this.setChildIndex(this.preloaderView.disp, 0);
        this.preloaderView.hideProgressBar();
        this.additionalFirstVisitScreenInitalization(firstVisitScreen);
    }

    protected additionalFirstVisitScreenInitalization(firstVisitScreen: ExtraScreenMovieClip): void {
    }

    private onFirstVisitAvatarCreationFinished(event: BasicFirstVisitEvent): void {
        this.removeChild(this.firstVisitSreen.disp);
        this.firstVisitSreen.removeEventListener(BasicFirstVisitEvent.AVATARCREATION_FINISHED, this.bindFunction(this.onFirstVisitAvatarCreationFinished));
        this.firstVisitSreen = null;

        // if (BasicModel.basicLoaderData.appLoader.hasQueEndElementFinished(BasicConstants.APP_LOADER)) {
        //     this.goToSecondFrame();
        // }
        // else {
        this.preloaderView.showProgressBar();
        // }
    }

    private loadingQueueAppLoaderFinished(loaderName: string = ""): void {
        this.preloaderUpdateTimer.stop();
        this.preloaderUpdateTimer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.onUpdatePreloaderView));
        if (this.preloaderView) {
            this.preloaderView.setProgressbarUpdateMethod(false);
        }
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.GAME_SWF_LOADED);
        //apploader has finished, now check if first visit screen is on screen, if not: go to second frame
        this.checkForFirstVisitScreen();
    }

    protected checkForFirstVisitScreen(): void {
        if (!this.firstVisitSreen) {
            // this.goToSecondFrame();
        }
    }

    // private /*final*/ isCookieEmpty(cookie: SharedObject): boolean { //TODO: @HTML5 handle cookies
    private /*final*/ isCookieEmpty(cookie: any): boolean {
        for (let property in cookie.data) {
            return false;
        }
        return true;
    }

    /**
     * Hook method to create preloader view.
     *
     * Example: preloaderView = new BasicPreloaderView();
     */
    protected createView(): void {
    }

    protected get mainGameClassName(): string {
        return "com.goodgamestudios.basic.BasicGame";
    }

    protected onBulkLoaderProgress(event: ProgressEvent): void {
        // this.preloaderView.updateLoadingProgress(Number(event.percentLoaded * 100));
        this.preloaderView.updateLoadingProgress((event.loaded / event.total) * 100);
    }

    private handleNewLoadingElementStarted(loaderName: string, subloaderName: string): void {
        if (this.preloaderView && this.preloaderView.disp && this.preloaderView.disp.visible) {
            let loaderObject: LoaderObject;

            if (loaderName == BasicModel.basicLoaderData.appLoader.loaderID) {
                loaderObject = BasicModel.basicLoaderData.appLoader.getLoaderObject(subloaderName);
            }

            if (loaderObject) {
                if (loaderObject.totalBytes > BasicConstants.MAX_FILESIZE_REALTIMELOADING) {
                    this.preloaderUpdateTimer.stop();
                    this.preloaderUpdateTimer.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.onUpdatePreloaderView));
                    this.preloaderView.startProgressBar();
                    this.preloaderView.setProgressbarUpdateMethod(false);
                } else {
                    this.preloaderView.stopProgressBar();

                    if (!this.preloaderUpdateTimer.running) {
                        this.preloaderUpdateTimer.addEventListener(TimerEvent.TIMER, this.bindFunction(this.onUpdatePreloaderView));
                        this.preloaderUpdateTimer.start();
                    }
                    this.preloaderView.setProgressbarUpdateMethod(true);
                    this.preloaderView.updateLoadingText(subloaderName);
                }
            }
        }
    }

    /**
     * updates the preloader for progress of appLoader
     */
    private onUpdatePreloaderView(event: TimerEvent): void {
        if (BasicModel.basicLoaderData.appLoader.isLoading || BasicModel.basicLoaderData.assetLoader.isRunning) {
            let loadRatio: number = 0;

            if (BasicModel.basicLoaderData.appLoader.isLoading) {
                loadRatio = BasicModel.basicLoaderData.appLoader.getProgressOfActualSubloader();
            }

            if (this.preloaderView && this.preloaderView.disp && this.preloaderView.disp.visible && !this.preloaderView.progressBarEnabled) {
                this.preloaderView.updateLoadingProgress(Number(loadRatio * 100));
            }
        }
    }

    protected handleLoadingElementFinished(loaderName: string, subloaderName: string): void {
        if (this.preloaderView) {
            this.preloaderView.updateLoadingProgress(100);
        }
    }

    protected goToSecondFrame(e: Event = null): void {
        let screenPlaceHolder: HTMLElement = document.getElementById("loading");
        if (screenPlaceHolder) {
            screenPlaceHolder.remove();
        }
        let body: HTMLElement = document.getElementsByTagName("body")[0];
        body.style.backgroundImage = "none";

        // try {
        // this.nextFrame(); //TODO: @HTML5 does not exist in createjs
        let gameClass: any = this.getMainGameClass();

        if (gameClass) {
            ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.GAME_SWF_LOADED);
            let event: ConnectionTrackingEvent = (<ConnectionTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.CONNECTION));
            // Store download rate of frame one
            BasicModel.basicLoaderData.downloadRateFrameOne = BasicModel.basicLoaderData.appLoader.calculateDataRate();

            if (event != null) {
                event.downloadRate = BasicModel.basicLoaderData.downloadRateFrameOne;
            } else {
                logger.error("cannot retrive ConnectionTrackingEvent");
            }
            let game: DisplayObject = new gameClass(this.preloaderView) as DisplayObject;
            this.addChild(game);
            (game as BasicGame).onAddedToStage();
        }
        /*  } catch (e) {
         fatal(e.message);
         }*/
    }

    protected getMainGameClass(): any { // expects type class
        return null;
        // FOR OVERRIDE
    }

    private loadXMLs(): void {
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.ITEM_XML_START);

        BasicModel.basicLoaderData.appLoader.addXMLLoader(
            BasicConstants.ITEM_XML_LOADER,
            PathProvider.instance.itemsXMLURL,
            URLLoaderDataFormat.TEXT,
            this.bindFunction(this.itemXMLComplete),
        );
    }

    protected /*final*/ itemXMLComplete(): void {
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.ITEM_XML_END);
        //this.loadAssets(); // TODO: @HTML5
        this.goToSecondFrame(); // TODO: @HTML5 - delete this line when the rest is fine
    }

    protected loadAssets(): void {
        /* TODO: @HTML5 unhandled BulkLoader, BulkProgressEvent classes*/
        // BasicModel.basicLoaderData.assetLoader.addEventListener(BulkLoader.PROGRESS, this.onBulkLoaderProgress);
        BasicModel.basicLoaderData.assetLoader.addEventListener(BulkLoader.COMPLETE, this.bindFunction(this.handleAssetLoaderComplete));
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.ASSETS_START);
        this.loadAdditionalAssets();

        for (let i: number = 1; i <= this.env.numOfItemLibs; i++) {
            BasicModel.basicLoaderData.assetLoader.add(
                PathProvider.instance.getItemSWFURL(i),
                {id: "itemLib" + i}
            );
        }
        BasicModel.basicLoaderData.assetLoader.start();
    }

    protected handleAssetLoaderComplete(event: Event): void {
        // Remove loading listeners
        /* TODO: @HTML5 unhandled BulkLoader, BulkProgressEvent classes */
        BasicModel.basicLoaderData.assetLoader.removeEventListener(BulkLoader.COMPLETE, this.bindFunction(this.handleAssetLoaderComplete));
        BasicModel.basicLoaderData.assetLoader.removeEventListener(BulkLoader.PROGRESS, this.bindFunction(this.onBulkLoaderProgress));
        // First instance tracking ASSETS_END
        ClientFunnelTrackingController.getInstance().trackState(ClientFunnelGameStates.ASSETS_END);
        // Assets loaded complete event
        BasicModel.basicLoaderData.dispatchEvent(new BasicAssetsEvent(BasicAssetsEvent.ASSETS_COMPLETE));

        if (this.preloaderView) {
            this.preloaderView.setProgressbarUpdateMethod(false);
        }
    }

    /**
     * @override
     */
    protected loadAdditionalAssets(): void {
        // FOR OVERRIDE
    }

    private onExitFrame(evt: Event): void {
        /* TODO: @HTML5 EXIT_FRAME event does not exist in createjs system
         if (this.currentFrame == 1 && this.framesLoaded == 1) {
         this.env.frameOneSizeInKB = Number(this.loaderInfo.bytesLoaded / 1024);

         if (this.env.frameOneSizeInKB == 0) {
         error("[ATTENTION]: first frame size reported with 0 bytes. Probably something went wrong. (Contact the dev of your trust)");
         }

         }
         if (this.env.isLocal && this.env.frameOneSizeInKB > 1024) {
         throw new Error("FrameOneSize " + "(" + this.env.frameOneSizeInKB + ")" + " is greater than 1024KB");
         }
         this.removeEventListener(Event.EXIT_FRAME, this.onExitFrame);
         */
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

}

